import { PLATFORM_SHARE_EDIT_SUPPORTED } from '@openx/components-deal/lib/components/EnableDataPartners/constants';
import { useAuth } from '../../../components/AuthContext/context';
import { isAdmin, isInternalUser } from '../../../permissions/validators';

export const useCanEditSegmentPartnerPlatformShare = (): boolean => {
  const { session } = useAuth();

  return PLATFORM_SHARE_EDIT_SUPPORTED && isAdmin(session) && isInternalUser(session);
};
